import { makeStyle } from '../../../utils';
import { h6, body2, black, blackMedium, button, blackOutline, caption, h5, columnCenter, overline, bold, secondary, subTitle1, rowCenter } from '../../../resources/styles';
import view from '../../../Enums';

const styles = {};

styles['no_property'] = makeStyle({}, { marginTop: 64 }, { marginTop: 48 }, { marginTop: 32 });

styles['empty_line_1'] = makeStyle({ ...h6, ...black, textAlign: 'center', margin: '26px 24px 0' });

styles['empty_line_2'] = makeStyle({ ...body2, ...blackMedium, textAlign: 'center', margin: '16px 24px 0' });

styles['add_property'] = makeStyle({
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    ...button,
});

styles['add_wrapper_style'] = makeStyle({
    maxWidth: 'calc(100% - 32px)',
    marginTop: 34,
})

styles['add_icon'] = makeStyle({
    marginRight: 10,
    height: 16, width: 16,
});

styles['why_oyo'] = makeStyle({
    borderRadius: 6,
    border: `1px solid ${blackOutline.color}`,
    padding: '32px 0 16px',
    width: 'calc(100% - 64px)', margin: 32,
    maxWidth: 1024,
});

styles['why_oyo_title'] = makeStyle({ ...h6, ...black, textAlign: 'center', letterSpacing: '-0.35px' });

styles['why_oyo_desc'] = makeStyle({ ...caption, ...blackMedium, padding: '0 12px', marginBottom: 16, textAlign: 'center', letterSpacing: '0.2px', marginTop: 8 });

styles['non_empty_container'] = makeStyle({}, { padding: 32 }, { padding: 32, paddingBottom: 200 }, { padding: 16, paddingBottom: 200 });

styles['error_title'] = makeStyle([h5, { color: 'var(--theme-color)' }]);

styles['error_desc'] = makeStyle([subTitle1, rowCenter, { justifyContent: 'center', marginTop: 8 }]);

styles['error_action'] = makeStyle([h6, bold, secondary, { cursor: 'pointer' }]);

styles['title'] = makeStyle({ ...h5, ...black, letterSpacing: '-0.28px' }, null, null, { display: 'none' });

styles['list'] = makeStyle({}, { display: 'flex', marginTop: 32, flexWrap: 'wrap' }, view.DESKTOP);

styles['add_card'] = makeStyle({ boxShadow: null });

styles['card'] = makeStyle({
    boxSizing: 'border-box',
    borderRadius: 6,
    overflow: 'hidden',
    boxShadow: 'var(--card-shadow)',
},
    { margin: '0 40px 40px 0' },
    { margin: '0 20px 20px 0' },
    { maxWidth: 353, margin: '0 auto 16px' }
);

styles['banner_wrapper'] = makeStyle({ padding: '0 32px 64px', width: 'max-content', margin: 'auto' });

styles['carousel'] = makeStyle(columnCenter, null, { display: 'none' }, view.TAB);

styles['footer'] = makeStyle({ width: '100%', zIndex: 100 }, { display: 'none' });

export default styles;